// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File Upload Container */
.file-upload-container {
  width: 100%;
  margin-bottom: 12px;
}

/* Upload Status Banner */
.upload-status {
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  border: 1px solid;
  animation: slideDown 0.3s ease-out;
}

.upload-status.success {
  background-color: #DCFCE7;
  border-color: #22C55E;
  color: #15803D;
}

[data-theme="dark"] .upload-status.success {
  background-color: #14532D;
  border-color: #22C55E;
  color: #22C55E;
}

.upload-status.error {
  background-color: #FEF2F2;
  border-color: #EF4444;
  color: #DC2626;
}

[data-theme="dark"] .upload-status.error {
  background-color: #7F1D1D;
  border-color: #EF4444;
  color: #FCA5A5;
}

.status-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-icon {
  flex-shrink: 0;
}

.status-message {
  flex: 1 1;
  font-size: 14px;
  font-weight: 500;
}

.status-close {
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  border-radius: 4px;
  color: inherit;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.status-close:hover {
  opacity: 1;
}

/* Upload Area */
.file-upload-area {
  border: 2px dashed #D1D5DB;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #F9FAFB;
  position: relative;
  overflow: hidden;
}

[data-theme="dark"] .file-upload-area {
  border-color: #374151;
  background-color: #1F2937;
}

.file-upload-area:hover:not(.uploading) {
  border-color: #3B82F6;
  background-color: #EFF6FF;
  transform: translateY(-1px);
}

[data-theme="dark"] .file-upload-area:hover:not(.uploading) {
  border-color: #60A5FA;
  background-color: #1E3A8A;
}

.file-upload-area.drag-active {
  border-color: #3B82F6;
  background-color: #EFF6FF;
  transform: scale(1.02);
}

[data-theme="dark"] .file-upload-area.drag-active {
  border-color: #60A5FA;
  background-color: #1E3A8A;
}

.file-upload-area.uploading {
  cursor: not-allowed;
  opacity: 0.7;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.upload-icon {
  color: #6B7280;
  margin-bottom: 4px;
}

[data-theme="dark"] .upload-icon {
  color: #9CA3AF;
}

.file-upload-area:hover:not(.uploading) .upload-icon {
  color: #3B82F6;
}

[data-theme="dark"] .file-upload-area:hover:not(.uploading) .upload-icon {
  color: #60A5FA;
}

.upload-text {
  margin: 0;
  font-size: 14px;
  color: #374151;
}

[data-theme="dark"] .upload-text {
  color: #D1D5DB;
}

.upload-primary {
  font-weight: 600;
  color: #3B82F6;
}

[data-theme="dark"] .upload-primary {
  color: #60A5FA;
}

.upload-secondary {
  margin: 0;
  font-size: 12px;
  color: #6B7280;
  margin-top: 4px;
}

[data-theme="dark"] .upload-secondary {
  color: #9CA3AF;
}

/* Upload Spinner */
.upload-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #E5E7EB;
  border-top: 2px solid #3B82F6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

[data-theme="dark"] .spinner {
  border-color: #374151;
  border-top-color: #60A5FA;
}

/* Supported File Types */
.supported-types {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.file-type-chip {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: #F3F4F6;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 500;
  color: #6B7280;
  border: 1px solid #E5E7EB;
}

[data-theme="dark"] .file-type-chip {
  background-color: #374151;
  border-color: #4B5563;
  color: #9CA3AF;
}

/* Enhanced Chat Input with Upload */
.enhanced-chat-input {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.input-with-upload {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
}

.upload-toggle-btn {
  background: #F3F4F6;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
}

[data-theme="dark"] .upload-toggle-btn {
  background-color: #374151;
  border-color: #4B5563;
}

.upload-toggle-btn:hover {
  background-color: #E5E7EB;
  border-color: #3B82F6;
}

[data-theme="dark"] .upload-toggle-btn:hover {
  background-color: #4B5563;
  border-color: #60A5FA;
}

.upload-toggle-btn.active {
  background-color: #3B82F6;
  border-color: #3B82F6;
  color: white;
}

.upload-toggle-btn svg {
  color: #6B7280;
}

[data-theme="dark"] .upload-toggle-btn svg {
  color: #9CA3AF;
}

.upload-toggle-btn:hover svg,
.upload-toggle-btn.active svg {
  color: currentColor;
}

/* Animations */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Compact upload area for chat input */
.file-upload-container.compact .file-upload-area {
  padding: 16px;
  font-size: 13px;
}

.file-upload-container.compact .upload-content {
  gap: 6px;
}

.file-upload-container.compact .upload-icon {
  width: 20px;
  height: 20px;
}

.file-upload-container.compact .supported-types {
  margin-top: 6px;
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .file-upload-area {
    padding: 16px;
  }
  
  .supported-types {
    gap: 6px;
  }
  
  .file-type-chip {
    font-size: 10px;
    padding: 3px 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/FileUpload.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* File Upload Container */\n.file-upload-container {\n  width: 100%;\n  margin-bottom: 12px;\n}\n\n/* Upload Status Banner */\n.upload-status {\n  padding: 8px 12px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  border: 1px solid;\n  animation: slideDown 0.3s ease-out;\n}\n\n.upload-status.success {\n  background-color: #DCFCE7;\n  border-color: #22C55E;\n  color: #15803D;\n}\n\n[data-theme=\"dark\"] .upload-status.success {\n  background-color: #14532D;\n  border-color: #22C55E;\n  color: #22C55E;\n}\n\n.upload-status.error {\n  background-color: #FEF2F2;\n  border-color: #EF4444;\n  color: #DC2626;\n}\n\n[data-theme=\"dark\"] .upload-status.error {\n  background-color: #7F1D1D;\n  border-color: #EF4444;\n  color: #FCA5A5;\n}\n\n.status-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.status-icon {\n  flex-shrink: 0;\n}\n\n.status-message {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.status-close {\n  background: none;\n  border: none;\n  padding: 2px;\n  cursor: pointer;\n  border-radius: 4px;\n  color: inherit;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n}\n\n.status-close:hover {\n  opacity: 1;\n}\n\n/* Upload Area */\n.file-upload-area {\n  border: 2px dashed #D1D5DB;\n  border-radius: 12px;\n  padding: 24px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background-color: #F9FAFB;\n  position: relative;\n  overflow: hidden;\n}\n\n[data-theme=\"dark\"] .file-upload-area {\n  border-color: #374151;\n  background-color: #1F2937;\n}\n\n.file-upload-area:hover:not(.uploading) {\n  border-color: #3B82F6;\n  background-color: #EFF6FF;\n  transform: translateY(-1px);\n}\n\n[data-theme=\"dark\"] .file-upload-area:hover:not(.uploading) {\n  border-color: #60A5FA;\n  background-color: #1E3A8A;\n}\n\n.file-upload-area.drag-active {\n  border-color: #3B82F6;\n  background-color: #EFF6FF;\n  transform: scale(1.02);\n}\n\n[data-theme=\"dark\"] .file-upload-area.drag-active {\n  border-color: #60A5FA;\n  background-color: #1E3A8A;\n}\n\n.file-upload-area.uploading {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.upload-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.upload-icon {\n  color: #6B7280;\n  margin-bottom: 4px;\n}\n\n[data-theme=\"dark\"] .upload-icon {\n  color: #9CA3AF;\n}\n\n.file-upload-area:hover:not(.uploading) .upload-icon {\n  color: #3B82F6;\n}\n\n[data-theme=\"dark\"] .file-upload-area:hover:not(.uploading) .upload-icon {\n  color: #60A5FA;\n}\n\n.upload-text {\n  margin: 0;\n  font-size: 14px;\n  color: #374151;\n}\n\n[data-theme=\"dark\"] .upload-text {\n  color: #D1D5DB;\n}\n\n.upload-primary {\n  font-weight: 600;\n  color: #3B82F6;\n}\n\n[data-theme=\"dark\"] .upload-primary {\n  color: #60A5FA;\n}\n\n.upload-secondary {\n  margin: 0;\n  font-size: 12px;\n  color: #6B7280;\n  margin-top: 4px;\n}\n\n[data-theme=\"dark\"] .upload-secondary {\n  color: #9CA3AF;\n}\n\n/* Upload Spinner */\n.upload-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.spinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #E5E7EB;\n  border-top: 2px solid #3B82F6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n[data-theme=\"dark\"] .spinner {\n  border-color: #374151;\n  border-top-color: #60A5FA;\n}\n\n/* Supported File Types */\n.supported-types {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.file-type-chip {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background-color: #F3F4F6;\n  border-radius: 16px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #6B7280;\n  border: 1px solid #E5E7EB;\n}\n\n[data-theme=\"dark\"] .file-type-chip {\n  background-color: #374151;\n  border-color: #4B5563;\n  color: #9CA3AF;\n}\n\n/* Enhanced Chat Input with Upload */\n.enhanced-chat-input {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.input-with-upload {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  width: 100%;\n}\n\n.upload-toggle-btn {\n  background: #F3F4F6;\n  border: 1px solid #D1D5DB;\n  border-radius: 8px;\n  padding: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  height: 40px;\n}\n\n[data-theme=\"dark\"] .upload-toggle-btn {\n  background-color: #374151;\n  border-color: #4B5563;\n}\n\n.upload-toggle-btn:hover {\n  background-color: #E5E7EB;\n  border-color: #3B82F6;\n}\n\n[data-theme=\"dark\"] .upload-toggle-btn:hover {\n  background-color: #4B5563;\n  border-color: #60A5FA;\n}\n\n.upload-toggle-btn.active {\n  background-color: #3B82F6;\n  border-color: #3B82F6;\n  color: white;\n}\n\n.upload-toggle-btn svg {\n  color: #6B7280;\n}\n\n[data-theme=\"dark\"] .upload-toggle-btn svg {\n  color: #9CA3AF;\n}\n\n.upload-toggle-btn:hover svg,\n.upload-toggle-btn.active svg {\n  color: currentColor;\n}\n\n/* Animations */\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Compact upload area for chat input */\n.file-upload-container.compact .file-upload-area {\n  padding: 16px;\n  font-size: 13px;\n}\n\n.file-upload-container.compact .upload-content {\n  gap: 6px;\n}\n\n.file-upload-container.compact .upload-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.file-upload-container.compact .supported-types {\n  margin-top: 6px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 640px) {\n  .file-upload-area {\n    padding: 16px;\n  }\n  \n  .supported-types {\n    gap: 6px;\n  }\n  \n  .file-type-chip {\n    font-size: 10px;\n    padding: 3px 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
